// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3n_bS","newExpiryDate":"styles_newExpiryDate__3q2HL","footer":"styles_footer__DXCCb"};